<template>
	<div id="ioMeasureControls">

		<img data-toggle="collapse" data-target="#intraoralMeasurePanel" aria-expanded="false" title="Measure Panel"
			src="images/menu_white.png" class="io-measure-panel-btn" />

		<!-- <div id="ioMeasureShowTeethLinesDiv" class="toggle-div" v-on:click.stop="setShowTeethLines($event)">
			<input id="ioMeasureShowTeethLinesButton" type="checkbox" checked />
			<div id="ioMeasureShowTeethLinesTitle" class="toggle-title"
				v-bind:style="{ color: isWhite ? blueColor : whiteColor }">Show Teeth Lines</div>
		</div>

		<div id="ioMeasureShowTeethNumbersDiv" class="toggle-div" v-on:click.stop="setShowTeethNumbers($event)">
			<input id="ioMeasureShowTeethNumbersButton" type="checkbox" checked />
			<div id="ioMeasureShowTeethNumbersTitle" class="toggle-title"
				v-bind:style="{ color: isWhite ? blueColor : whiteColor }">Show Teeth Numbers</div>
		</div>

		<div id="ioMeasureShowCrossLinesDiv" class="toggle-div" v-on:click.stop="setShowCrossLines($event)">
			<input id="ioMeasureShowCrossLinesButton" type="checkbox" checked />
			<div id="ioMeasureShowCrossLinesTitle" class="toggle-title"
				v-bind:style="{ color: isWhite ? blueColor : whiteColor }">Show Cross Lines</div>
		</div> -->
		<!-- 
		<label v-show="editContext.sumDistance" id="ioMeasureSumLabel" class="measure-label"
			v-bind:style="{ color: editContext.isWhite ? editContext.blueColor : editContext.whiteColor }">Sum Distance:
			{{ editContext.sumDistance.toFixed(2) }} mm
		</label>

		<label id="ioMeasureTotalLabel" class="measure-label"
			v-bind:style="{ color: editContext.isWhite ? editContext.blueColor : editContext.whiteColor }">Total
			Distance: {{
			editContext.totalDistance.toFixed(2) }} mm
		</label>

		<label id="ioMeasurePremolarLabel" class="measure-label"
			v-bind:style="{ color: editContext.isWhite ? editContext.blueColor : editContext.whiteColor }">Premolar
			Distance: {{ editContext.premolarDistance.toFixed(2) }}
			mm</label>

		<label id="ioMeasureFirstSixLabel" class="measure-label"
			v-bind:style="{ color: editContext.isWhite ? editContext.blueColor : editContext.whiteColor }">First Six
			Distance: {{ editContext.firstSixDistance.toFixed(2) }}
			mm</label> -->

		<!-- <button class="measure-button measure-panel-button" v-on:click="switchPanel()">
			MEASURE PANEL
		</button>

		<button class="measure-button measure-save-button" v-on:click="exitMeasureMode(true)">
			SAVE
		</button>

		<button class="measure-button measure-cancel-button" v-on:click="exitMeasureMode(false)">
			CANCEL
		</button> -->
	</div>
</template>

<script>

import {
	switchShowTeethLines, switchShowCrossLines, switchShowTeethNumbers, leaveMeasureMode
} from "./IntraoralMeasureMode.js";

export default {
	name: "IntraoralMeasureControls",
	props: ["editContext"],
	components: {},
	methods: {
		setShowTeethLines: function (event) {
			this.editContext.showTeethLines = !this.editContext.showTeethLines;
			if (event) {
				switchToggle(event.currentTarget.id, this.editContext.showTeethLines);
			}
			switchShowTeethLines(this.editContext.showTeethLines);
		},
		setShowTeethNumbers: function (event) {
			this.editContext.showTeethNumbers = !this.editContext.showTeethNumbers;
			if (event) {
				switchToggle(event.currentTarget.id, this.editContext.showTeethNumbers);
			}
			switchShowTeethNumbers(this.editContext.showTeethNumbers);
		},
		setShowCrossLines: function (event) {
			this.editContext.showCrossLines = !this.editContext.showCrossLines;
			if (event) {
				switchToggle(event.currentTarget.id, this.editContext.showCrossLines);
			}
			switchShowCrossLines(this.editContext.showCrossLines);
		},
		switchPanel: function () {
			this.editContext.showPanel = !this.editContext.showPanel;
			if (this.editContext.showPanel) {
				$(`#intraoralMeasurePanel`).addClass("show");
			} else {
				$(`#intraoralMeasurePanel`).removeClass("show");
			}
		},
		exitMeasureMode: function (saveChanges) {
			leaveMeasureMode(saveChanges);
		}
	},
	mounted: function () {
		canecode_switch("#ioMeasureShowTeethLinesButton");
		canecode_switch("#ioMeasureShowCrossLinesButton");
		canecode_switch("#ioMeasureShowTeethNumbersButton");
	}
};

</script>

<style scoped>
#ioMeasureControls {
	position: absolute;
	cursor: pointer;
	z-index: 9;
	top: 56px;
	right: 79px;
	/* font-size: medium;
	font-weight: normal;
	left: calc(50% - 300px);
	bottom: 75px;
	display: none;
	width: 600px;
	height: 70px;
	*/
}

.io-measure-panel-btn {
	/* cursor: pointer;
	position: absolute;
	top: 50px;
	left: 14px; */
	width: 30px;
	height: 30px;
}

.toggle-div {
	bottom: 50px;
	position: absolute;
	text-align: center;
	z-index: 9;
	color: #ffffff;
	width: auto;
}

.toggle-title {
	font-size: medium;
	font-weight: normal;
	width: 190px;
}

#ioMeasureShowTeethLinesDiv {
	left: calc(50% - 135px);
	margin-left: -56px;
}

#ioMeasureShowTeethLinesTitle {
	margin-left: -56px;
}

#ioMeasureShowTeethNumbersDiv {
	left: calc(50% - 10px);
}

#ioMeasureShowTeethNumbersTitle {
	margin-left: -56px;
}

#ioMeasureShowCrossLinesDiv {
	left: calc(50% + 160px);
}

#ioMeasureShowCrossLinesTitle {
	margin-left: -56px;
}



.measure-label {
	text-align: center;
	color: #ffffff;
	position: absolute;
	z-index: 9;
	width: 250px;
	left: calc(50% - 100px);
}

#ioMeasureSumLabel {
	bottom: 210px;
}

#ioMeasureTotalLabel {
	bottom: 180px;
}

#ioMeasurePremolarLabel {
	bottom: 150px;
}

#ioMeasureFirstSixLabel {
	bottom: 120px;
}

.measure-button {
	position: absolute;
	bottom: 0;
	display: inline-block;
	min-width: 90px;
	width: auto;
	height: 35px;
	border: 0;
	cursor: pointer;
	font-size: small;
	background-color: #4687fc;
	/*#F7FAFF;*/
	text-align: center;
	color: #ffffff;
	z-index: 99;
}

.measure-panel-button {
	left: calc(50% - 152px);
}

.measure-save-button {
	left: calc(50% - 2px);
}

.measure-cancel-button {
	left: calc(50% + 107px);
}
</style>